export const ITEMTYPE = {
  FILE: 'fileFields',
  FOLDER: 'folderFields',
};
